import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { apiClient } from './client'
import { queryKeys } from '../lib/query'

interface NotificationPreferences {
  id: string
  userId: string
  notifyNewLeads: boolean
  notifyProjectStatus: boolean
  notifyDeadlines: boolean
  notifyPayments: boolean
}

export function useNotificationPreferences() {
  return useQuery({
    queryKey: ['settings', 'preferences'],
    queryFn: () => apiClient<NotificationPreferences>('/settings/preferences'),
  })
}

export function useUpdateNotificationPreferences() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data: Partial<NotificationPreferences>) =>
      apiClient<NotificationPreferences>('/settings/preferences', {
        method: 'PATCH',
        body: JSON.stringify(data),
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['settings', 'preferences'] })
    },
  })
}

// AI Status
interface AiModel {
  id: string
  name: string
  description: string
}

interface AiStatus {
  configured: boolean
  model: string
  availableModels: AiModel[]
}

export function useAiStatus() {
  return useQuery({
    queryKey: queryKeys.settings.ai,
    queryFn: () => apiClient<AiStatus>('/settings/ai-status'),
  })
}

export function useUpdateAiModel() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (model: string) =>
      apiClient<{ model: string }>('/settings/ai-model', {
        method: 'PATCH',
        body: JSON.stringify({ model }),
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.settings.ai })
    },
  })
}
